import { ApolloClient, InMemoryCache, createHttpLink } from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";

import StorageService from "services/Storage";

type Error =
  | {
      message: string;
      status: number;
    }
  | Record<string, unknown>;

const httpLink = createHttpLink({
  uri: process.env.REACT_APP_API_URI,
});

const authLink = setContext((_, { headers }) => {
  const authToken = StorageService.getUserToken();
  return {
    headers: {
      ...headers,
      authorization: authToken ? `Bearer ${authToken}` : "",
    },
  };
});

const errorLink = onError(({ graphQLErrors }) => {
  const err = ((graphQLErrors && graphQLErrors?.length > 0 && graphQLErrors[0]) || {}) as Error;
  if (err && err.status === 401) {
    StorageService.removeUserToken();
  }
});

const client = new ApolloClient({
  link: errorLink.concat(authLink.concat(httpLink)),
  cache: new InMemoryCache({
    typePolicies: {
      Query: {
        fields: {
          // Define any field policies if needed
        },
      },
    },
  }),
});

export default client;
